import ProjectPage from "pages/ProjectPage";
import TermsAndContionsPage from "pages/TermsAndConditionsPage";
import { Route, Routes } from "react-router-dom";
import CreateAccountPage from "../pages/CreateAccountPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import Home from "../pages/Home";
import LoginPage from "../pages/LoginPage";
import MailSentPage from "../pages/MailSentPage";
import NotFoundPage from "../pages/NotFoundPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import setInterceptors from "../services/setInterceptors";
import NewAccount from "./CreateAccount/NewAccount";
import PrivateRoute from "./Shared/PrivateRoute";

const RouterRoot = function () {
  setInterceptors();

  return (
    <Routes>
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/create-account" element={<CreateAccountPage />} />
      <Route path="/new/account" element={<NewAccount />} />
      <Route path="/:component/:id" element={<ProjectPage />} />
      <Route path="/terms" element={<TermsAndContionsPage />} />
      <Route path="/:component" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/email-sent" element={<MailSentPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default RouterRoot;
